import {
  Box,
  Button,
  Card,
  Checkbox,
  Divider,
  Group,
  NumberInput,
  Stack,
  Title,
} from "@mantine/core";
import {useState} from "react";
import {LogoutButton} from "./LogoutButton";

export function SettingsSection() {
  const [dailyGoal, setDailyGoal] = useState(20);
  const [isPublicProfile, setIsPublicProfile] = useState(true);

  const handleExportData = () => {
    // TODO: Implement data export when storage layer is ready
    alert("Data export will be available once the storage layer is implemented.");
  };

  const handleClearCache = () => {
    // TODO: Implement cache clearing when storage layer is ready
    if (
      confirm(
        "Are you sure you want to clear the local cache? This will not delete your data from the server.",
      )
    ) {
      alert("Cache clearing will be available once the storage layer is implemented.");
    }
  };

  return (
    <Card withBorder radius="lg" p="xl" className="glass-card" bg="transparent">
      <Title order={3} size="h4" mb="xl">
        Settings
      </Title>

      <Stack gap="xl">
        {/* Daily Goal */}
        <Box>
          <NumberInput
            label="Daily Study Goal (items)"
            description="Number of items you want to review each day"
            min={1}
            max={100}
            value={dailyGoal}
            onChange={val => setDailyGoal(Number(val))}
            maw={200}
            size="md"
          />
        </Box>

        {/* Privacy Settings */}
        <Box>
          <Checkbox
            label="Public Profile (allow others to view your study lists)"
            description="Your study data is stored in your ATProto repository and is public by default"
            checked={isPublicProfile}
            onChange={e => setIsPublicProfile(e.target.checked)}
            size="md"
          />
        </Box>

        {/* Data Management */}
        <Box>
          <Title order={4} size="h5" mb="md">
            Data Management
          </Title>
          <Group gap="sm">
            <Button
              variant="outline"
              color="gray"
              onClick={handleExportData}
              leftSection="📥"
            >
              Export My Data
            </Button>
            <Button
              variant="outline"
              color="gray"
              onClick={handleClearCache}
              leftSection="🗑️"
            >
              Clear Local Cache
            </Button>
          </Group>
        </Box>

        <Divider />

        {/* Logout */}
        <Box>
          <Title order={4} size="h5" mb="md">
            Account
          </Title>
          <LogoutButton />
        </Box>
      </Stack>
    </Card>
  );
}
